import React from 'react'
import Icon from '@ant-design/icons';

export default (props) => {
  const {
    color, // цвет знака
    colorShadow, // цвет обводки

    width,
    height,

    style: {
      width: style_width,
      height: style_height,
      color: style_color,
    } = {},
    ...rest
  } = props;

  const fill_color = color || style_color || '#1A5265';
  const shadow_fill_color = colorShadow || style_color || 'white';

  const w = width || style_width || 20;
  const h = height || style_height || 23;

  const SvgIcon = () => (
    <svg
      width={w}
      height={h}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 16.8481C3.67886 19.5237 5.95835 21.5 8.66758 21.5H13.1207C16.3717 21.5 19 18.6704 19 15.1862V7.81376C19 4.32964 16.3655 1.5 13.1207 1.5H8.66758C5.95835 1.5 3.67886 3.46984 3 6.15191M1 11.5H14M14 11.5L9 6.5M14 11.5L9 16.5"
        stroke={shadow_fill_color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 16.8481C3.67886 19.5237 5.95835 21.5 8.66758 21.5H13.1207C16.3717 21.5 19 18.6704 19 15.1862V7.81376C19 4.32964 16.3655 1.5 13.1207 1.5H8.66758C5.95835 1.5 3.67886 3.46984 3 6.15191M1 11.5H14M14 11.5L9 6.5M14 11.5L9 16.5"
        stroke={fill_color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return <Icon component={SvgIcon} {...rest} />;
}
